<template>
    <div
      :id="$vId(this, 'trigger')"
      :class="$style.clickArea"
      @click.stop="show()"
    >
      <slot
        name="trigger"
        :active="active"
        :disabled="disabled"
      />
    </div>
</template>

<script type="text/ecmascript-6">
import {mapGetters} from 'vuex'

export default {
  name: 'FouModal',

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    cols: {
      type: [String, Number, Object],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      active: false
    }
  },

  methods: {
    show() {
      if (!this.disabled) {
        this.$store
          .dispatch('overlay/show', {
            content: this.$slots.content?.(),
            cols: this.cols
          })
          .then(() => {
            this.active = true
          })
      }
    }
  },

  computed: {
    ...mapGetters('overlay', ['visibility'])
  },

  watch: {
    /**
     * Visibility of overlay: When false reset active state to false.
     */
    visibility: function (v) {
      if (!v) {
        this.active = false
      }
    }
  },

  created() {
    if (this.visible) {
      /**
       * if visible by default slots get not always detected correctly.
       * Maybe this could be solved, by adding all this template logic here to a render hook.
       */
      this.show()
    }
  }
}
</script>

<style lang="scss" module>
.clickArea {
  display: inline-flex;
}
</style>
